export default {
  ApartmentSuiteFormField__ARIA: "Apartment or Suite number",
  ApartmentSuiteFormField__LABEL: "Apt/Suite",
};
